<div class="json-tree">
  <!-- Context Menu - ONLY created at root level (level 0) -->
  @if (level === 0) {
    <ejs-contextmenu
      #contextMenu
      [items]="menuItems"
      (select)="onContextMenuSelect($event)"
      cssClass="json-context-menu"
    ></ejs-contextmenu>
  }

  @if (level === 0 && shouldShowNoResults()) {
    <!-- No results message at root level -->
    <div class="no-results">
      <div class="no-results-icon">🔍</div>
      <div class="no-results-text">No matching results found</div>
    </div>
  } @else if (isPrimitive()) {
    <!-- Primitive values - Single row -->
    <div class="json-row" (contextmenu)="onItemContextMenu($event, displayKey, data)">
      @if (displayKey) {
        <span class="json-key">{{ displayKey }}</span>
        <span class="json-colon">: </span>
      }
      <span class="json-value" [class]="valueClass()">{{ formattedValue() }}</span>
    </div>
  } @else if (isArray() || isObject()) {
    @if (isEmpty()) {
      <!-- Empty array or object - Single row without arrow -->
      <div class="json-row" (contextmenu)="onItemContextMenu($event, displayKey, data)">
        @if (displayKey) {
          <span class="json-key">{{ displayKey }}</span>
          <span class="json-colon">: </span>
        }
        <span class="json-bracket">{{ isArray() ? '[' : '&#123;' }}</span>
        <span class="json-bracket">{{ isArray() ? ']' : '&#125;' }}</span>
      </div>
    } @else if (!expanded()) {
      <!-- Collapsed state - Single row with arrow, key, and preview -->
      <div
        class="json-row json-row-expandable"
        (click)="toggleExpand()"
        (contextmenu)="onItemContextMenu($event, displayKey, data)"
      >
        <span class="json-arrow">▶</span>
        @if (displayKey) {
          <span class="json-key">{{ displayKey }}</span>
          <span class="json-colon">: </span>
        }
        <span class="json-bracket">{{ isArray() ? '[' : '&#123;' }}</span>
        <span class="json-preview">{{ isArray() ? arrayPreview() : objectPreview() }}</span>
        <span class="json-bracket">{{ isArray() ? ']' : '&#125;' }}</span>
      </div>
    } @else {
      <!-- Expanded state -->
      <div class="json-expanded-container">
        <!-- Header row with arrow and opening bracket (skip for root level) -->
        @if (level > 0) {
          <div
            class="json-row json-row-expandable"
            (click)="toggleExpand()"
            (contextmenu)="onItemContextMenu($event, displayKey, data)"
          >
            <span class="json-arrow json-arrow-expanded">▼</span>
            @if (displayKey) {
              <span class="json-key">{{ displayKey }}</span>
              <span class="json-colon">: </span>
            }
            <span class="json-bracket">{{ isArray() ? '[' : '&#123;' }}</span>
          </div>
        }

        <!-- Children with indentation -->
        <div class="json-children" [class.json-children-root]="level === 0">
          @if (isArray()) {
            @for (item of filteredArrayItems(); track item.index) {
              <app-json-tree
                [data]="item.value"
                [level]="level + 1"
                [searchQuery]="searchQuery"
                [path]="buildPath(item.index.toString())"
                [displayKey]="item.index.toString()"
                (contextMenuTriggered)="onChildContextMenu($event)"
              />
            }
          } @else {
            @for (key of filteredObjectKeys(); track key) {
              <app-json-tree
                [data]="data[key]"
                [level]="level + 1"
                [searchQuery]="searchQuery"
                [path]="buildPath(key)"
                [displayKey]="key"
                (contextMenuTriggered)="onChildContextMenu($event)"
              />
            }
          }
        </div>

        <!-- Closing bracket row (skip for root level) -->
        @if (level > 0) {
          <div class="json-row">
            <span class="json-bracket">{{ isArray() ? ']' : '&#125;' }}</span>
          </div>
        }
      </div>
    }
  }
</div>